(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    (() => {
    const TAG = 'accordion-custom';

    if (customElements.get(TAG)) return;

    class AccordionCustom extends HTMLElement {
      connectedCallback() {
        this.addEventListener('toggle', this.#handleToggle, true);
      }

      disconnectedCallback() {
        this.removeEventListener('toggle', this.#handleToggle, true);
      }

      #handleToggle = (event) => {
        // Product overview (and theme-block accordions) keep one-at-a-time open.
        // FAQ metafield lists opt out via missing data-exclusive.
        if (!this.hasAttribute('data-exclusive')) return;

        const target = event.target;

        if (!(target instanceof HTMLDetailsElement) || !this.contains(target)) return;
        if (!target.open) return;

        // Defer sibling closes. Synchronous closes during `toggle` break open /
        // close on iOS Safari when switching between rows.
        queueMicrotask(() => {
          if (!target.open || !this.isConnected) return;

          for (const details of this.querySelectorAll(':scope > details.accordion-row')) {
            if (details !== target && details.open) {
              details.open = false;
            }
          }
        });
      };
    }

    customElements.define(TAG, AccordionCustom);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-specs-tooltip"] && !Shopify.designMode) return;
  try {
    (() => {
    const CLOSE_SELECTOR = '.product-specs__tooltip-close';
    const DETAILS_SELECTOR = 'details.product-specs__tooltip';
    const ITEM_SELECTOR = '.product-specs__item';
    const ITEM_OPEN_CLASS = 'product-specs__item--tooltip-open';

    if (document.documentElement.dataset.productSpecsTooltipCloseInit === 'true') return;

    document.documentElement.dataset.productSpecsTooltipCloseInit = 'true';

    const setItemOpenState = (details) => {
      const item = details.closest(ITEM_SELECTOR);

      if (!item) return;

      item.classList.toggle(ITEM_OPEN_CLASS, details.open);
    };

    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;

        if (!(details instanceof HTMLDetailsElement) || !details.matches(DETAILS_SELECTOR)) return;

        setItemOpenState(details);
      },
      true
    );

    document.addEventListener('click', (event) => {
      const button = event.target.closest(CLOSE_SELECTOR);

      if (!button) return;

      const details = button.closest(DETAILS_SELECTOR);

      if (details instanceof HTMLDetailsElement) {
        details.open = false;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
